export class structBuilder {
	constructor(key?: string, value?: any) {
		if (key !== undefined && value !== undefined) {
			this.setKey(key, value);
		}
	}

	private _struct: { [key: string]: any } = {};

	set struct(struct: { [key: string]: any }) {
		this._struct = struct;
	}

	get struct() {
		return this._struct;
	}

	setKey(key: string, value: any) {
		this._struct[key] = value;
		return this;
	}

	getKey(key: string) {
		return this._struct[key];
	}
}
